$(document).ready(function () {
  // $(".accordion-content:not(:first-of-type)").css("display", "none");
  // $(".js-accordion-title:first-of-type").addClass("open");
  $(".js-accordion-title").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });

  var $sliderMain = $(".slider-for");
  var $sliderNav = $(".slider-nav");

  $sliderMain.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    fade: true,
    dots: true,
    infinite: false,
    prevArrow:
      '<button type="button" class="slick-prev"><i class="fa fa-angle-up"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next"><i class="fa fa-angle-down"></i></button>',
    asNavFor: $sliderNav,
  });
  $sliderNav.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: $sliderMain,
    dots: false,
    arrows: true,
    infinite: false,
    prevArrow:
      '<button type="button" class="slick-prev"><i class="fa fa-angle-up"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next"><i class="fa fa-angle-down"></i></button>',
    focusOnSelect: true,
    verticalSwiping: true,
    useTransform: true,
  });
  $(".hercules-all-reviews").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplaySpeed: 3000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: false,
        },
      },
    ],
  });

  $(".hercules-Preferred-blocks").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    autoplaySpeed: 3000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  setTimeout(function () {
    jQuery(".product .banner-slider").css("opacity", "1");
  }, 1);
});

var ownData;
$(document).ready(function () {
  function onVariantChange(data) {
    var variantData = data.data.variant;
    var selling_plan = 0;
    var original_price = 0;
    console.log("Variant changed!", variantData);
    ownData = data;
    selling_plan = "$" + variantData.selling_plan_allocations[0]["price"] / 100;
    original_price = "$" + variantData.price / 100;

    var render_text = "";
    console.log(variantData.price);
    if (variantData.price == 4999) {
      render_text = "VIP OFFER: $49.99 Buy 1 Get 1 Free (Bonus $30 Off)";
    } else if (variantData.price == 7999) {
      render_text = "VIP OFFER: $59.99 Buy 2 Get 2 Free (Bonus $50 Off)";
    } else if (variantData.price == 10999) {
      render_text = "VIP OFFER: $79.99 Buy 3 Get 3 Free (Bonus $70 Off)";
    }
    console.log(render_text);
    $(".selling_plan").each(function () {
      $(this).text(render_text);
    });

    $(".original_price").each(function () {
      $(this).text(original_price);
    });
  }
  subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
});

//09/09/24

// Function to create and insert the new div
function addNewDiv() {
  // Select the existing div with the class .rc-radio.subscription-radio
  const targetDiv = document.querySelector(
    ".page-bulletproof-ver-1 .rc-radio.subscription-radio"
  );

  if (targetDiv) {
    // Create the new div with the class subspoint
    const newDiv = document.createElement("div");
    newDiv.className = "subspoint";

    // Create the ul element
    const ul = document.createElement("ul");

    // Create and append li elements with content
    const listItems = [
      "<strong>Free Shipping</strong> Every Month",
      "<strong>No Contract</strong> Cancel Easily",
      "<strong>10% Off</strong> Future Orders",
      "<strong>Out Of Stock Protection</strong>"
    ];

    listItems.forEach(item => {
      const li = document.createElement("li");
      li.innerHTML = item;
      ul.appendChild(li);
    });

    // Append the ul to the new div
    newDiv.appendChild(ul);

    // Insert the new div after the target div
    targetDiv.insertAdjacentElement("afterend", newDiv);
  }

  // Select the element for the second operation
  var targetElement = document.querySelector(
    ".page-bulletproof-ver-2 .rc-radio.subscription-radio .rc-radio__label"
  );

  if (targetElement) {
    // Create a new <p> element
    var newParagraph = document.createElement("p");
    newParagraph.className = "subscomment";

    // Optionally set some content for the <p> element
    newParagraph.innerHTML = "Lock in <span>20% off</span> and never run out";

    // Append the <p> element after the target element
    if (targetElement.parentNode) {
      targetElement.parentNode.insertBefore(
        newParagraph,
        targetElement.nextSibling
      );
    }
  }
}
// Function to append one-time price as a span within the subscription price label
function appendOneTimePriceToSubscription() {
  // Select the price from the one-time purchase option
  const oneTimePriceLabel = document.querySelector(
    ".onetime-radio .price-label"
  );
  const oneTimePrice = oneTimePriceLabel
    ? oneTimePriceLabel.textContent.trim()
    : "";

  // Create a new span element to hold the one-time price
  const oneTimePriceSpan = document.createElement("span");
  oneTimePriceSpan.textContent = oneTimePrice; // Use textContent for better text handling

  // Select all subscription price labels
  const subscriptionPriceLabels = document.querySelectorAll(
    ".subscription-radio .price-label"
  );

  // Insert the one-time price span before each subscription price label
  subscriptionPriceLabels.forEach((subscriptionPriceLabel) => {
    const clonedOneTimePriceSpan = oneTimePriceSpan.cloneNode(true); // Clone the span to ensure each one is unique
    subscriptionPriceLabel.insertBefore(
      clonedOneTimePriceSpan,
      subscriptionPriceLabel.firstChild
    );
  });
}

// Call both functions after a 2-second delay
window.addEventListener("load", function () {
  setTimeout(function () {
    addNewDiv();
    appendOneTimePriceToSubscription();
  }, 1500);
});

// Delay the script execution by 2 seconds
setTimeout(function () {
  // Select checkboxes
  const subscriptionCheckbox = document.querySelector(
    'input[type="radio"][value="subscription"]'
  );
  const ontimeCheckbox = document.querySelector(
    'input[type="radio"][value="onetime"]'
  );

  if (!subscriptionCheckbox || !ontimeCheckbox) {
    console.error("One or both checkboxes not found.");
    return;
  }

  // Store original prices for resetting later
  const originalPrices = new Map();

  // Function to initialize prices and store original values
  function initializePrices() {
    const priceElements = document.querySelectorAll(".money");

    priceElements.forEach(function (element) {
      // Extract numeric value from text content
      let originalPrice = parseFloat(
        element.textContent.replace(/[^0-9.]/g, "")
      );

      if (isNaN(originalPrice)) {
        console.error(
          "Original price is not a valid number:",
          element.textContent
        );
        return;
      }

      // Store the original price in a map
      originalPrices.set(element, originalPrice);
    });

    // Update prices based on the initial state of the checkboxes
    updatePrices();
  }

  // Function to update the prices
  function updatePrices() {
    const priceElements = document.querySelectorAll(".money");

    if (priceElements.length === 0) {
      console.error("No price elements found.");
      return;
    }

    priceElements.forEach(function (element) {
      // Retrieve the original price
      let originalPrice = originalPrices.get(element);

      if (originalPrice === undefined) {
        console.error("Original price not found for element:", element);
        return;
      }

      let displayedPrice = originalPrice;

      // Apply discount if subscription checkbox is checked
      if (subscriptionCheckbox.checked) {
        displayedPrice = originalPrice * 0.75; // Apply 25% discount
      }

      // Adjust price further based on ontime checkbox
      if (ontimeCheckbox.checked) {
        displayedPrice = subscriptionCheckbox.checked
          ? displayedPrice * 1.25 // Increase by 25% if subscription is also checked
          : originalPrice; // Revert to original price if subscription is not checked
      }

      // Update the price display
      element.textContent = displayedPrice.toFixed(2);
    });
  }

  // Initialize prices and update on page load
  initializePrices();

  // Update prices on checkbox change
  subscriptionCheckbox.addEventListener("change", updatePrices);
  ontimeCheckbox.addEventListener("change", updatePrices);
}, 1500); // 2000 milliseconds = 2 seconds

$(".button-reviews").on("click", function () {
  setTimeout(() => {
    const reviewButton = document.querySelector(
      "a.oke-w-writeReview.oke-button"
    );
    if (reviewButton) {
      reviewButton.click();
    }
  }, 500);
});
$(document).ready(function () {
  var isProcessing = false;

$(".add-to-cart-btn").click(function(e) {
    e.preventDefault();

    // If the request is already processing, do nothing
    if (isProcessing) return;
    isProcessing = true;

    // Show the loader
   // $("#loader").show();  // Display the loader

    $(this).css("pointer-events", "none");  // Disable the button

    var itemsArray = [];
    var mainItem = {};
    mainItem["id"] = parseInt($("input[name='id']").val());
    mainItem["quantity"] = 1;
    mainItem["selling_plan"] = parseInt($(this).attr('data-sellingplan'));
    $(".prodct_free_list .free_product").each(function() {
        var subItem = {};
        var thisID = parseInt($(this).attr("id"));
        console.log(thisID);
        subItem["id"] = thisID;
        subItem["quantity"] = 1;
        subItem["properties"] = { '_item_type': "subitem" };
        itemsArray.push(subItem);
    });

    itemsArray.unshift(mainItem);
    itemsArray.reverse();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { 'items': itemsArray },
        dataType: 'json',
        success: function(data) {
            // Hide the loader once the request is complete
            $("#loader").hide();

            $(".add-to-cart-btn").css("pointer-events", "auto");  // Re-enable the button
             window.location.href = '/checkout'; 
        },
        error: function() {
            // Hide the loader in case of an error
           // $("#loader").hide();
            
            $(".add-to-cart-btn").css("pointer-events", "auto");  // Re-enable the button
             window.location.href = '/checkout'; 
            isProcessing = false;  // Reset processing state
        }
    });
});
 $(".remove_cart").off("click").on("click", function (e) {
     console.log("method called");
  e.preventDefault();
  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    dataType: "json",
    success: function (response) {
      console.log("Cart cleared successfully");
    },
    error: function (error) {
      console.log("Error clearing cart:", error);
    },
  });
});
});
